<template>
  <div :style="styles.base">
    <div :class="getCss('sharePageBtn')" @click="clickBtn()" :style="shareBtnImage">
      <div :class="getCss('btnText')" ></div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
export default {
  name: 'CShanxianSharePageBtn',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-share-page-btn-',
      activityLink: `${window.location.href.split('?')[0]}?c_page=0`,
    };
  },
  computed: {
    shareBtnImage() { // 底图
      if (this.configurationData.useSprites === true) {
        return {
          backgroundSize: '10.9rem 6.9rem',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '-0.3rem -5.8rem',
          backgroundImage: `url(${this.configurationData.shareBtnImage})`,
        };
      }
      return {
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${this.configurationData.shareBtnImage})`,
      };
    },
    getPageType() {
      return this.configurationData.pageType;
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      const that = this;
      if (this.getPageType === 1) {
        setTimeout(() => {
          // console.log('H5端外投放页_页面访问', this.getPageType);
          this.$pluginSparkReport.sparkBaseReport(that.pageInfo.canvasConfig.reportPv, '2501', '00002', '02', '01');
        }, 100);
      } else if (this.getPageType === 2) {
        setTimeout(() => {
          // console.log('H5端外分享页_页面访问', this.getPageType);
          this.$pluginSparkReport.sparkBaseReport(that.pageInfo.canvasConfig.reportPv, '2501', '00002', '02', '02');
        }, 100);
      } else if (this.getPageType === 3) {
        setTimeout(() => {
          // console.log('H5端外助力页_页面访问', this.getPageType);
          this.$pluginSparkReport.sparkBaseReport(that.pageInfo.canvasConfig.reportPv, '2501', '00002', '02', '03');
        }, 100);
      } else {
        console.log('未明确的页面类型', this.getPageType);
      }
    },
    clickBtn() {
      if (this.getPageType === 1) {
        // console.log('H5端外投放页_立即领取按钮点击', this.getPageType);
        this.$pluginSparkReport.sparkBaseReport(this.pageInfo.canvasConfig.reportPv, '2501', '00002', '03', '01');
      } else if (this.getPageType === 2) {
        // console.log('H5端外分享页_助力按钮点击', this.getPageType);
        this.$pluginSparkReport.sparkBaseReport(this.pageInfo.canvasConfig.reportPv, '2501', '00002', '03', '02');
      } else if (this.getPageType === 3) {
        // console.log('H5端外助力页_助力按钮点击', this.getPageType);
        this.$pluginSparkReport.sparkBaseReport(this.pageInfo.canvasConfig.reportPv, '2501', '00002', '03', '03');
      } else {
        console.log('未明确的页面类型', this.getPageType);
      }

      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      this.activityLink = common.tool.passThroughUrlParam(this.activityLink, ['via', 'trace_id', 'via_source']);
      
      if (window?.SX_WEB.tool.env.isApp === false) {
         console.log('this.getPageType', this.getPageType);
         console.log('this.activityLink', this.activityLink);
        if (this.getPageType === 1) {
          this.$astSparkPlugin.gotoAPP(this.activityLink, { ch: this.configurationData.channelID });
          return;
        }
        let param = '';
        if (window?.SX_WEB.tool.env.ios) {
          param = encodeURIComponent(window.location.search.substring(1));
        } else {
          param = window.location.search.substring(1);
        }
        //由于地址上有两个c_page，有时候会导致跳转不到活动页，所以在最后再加一个
        const url = `${this.activityLink}&atype=invite&${param}&c_page=0`;
        console.log('跳转地址', url);
        this.$astSparkPlugin.gotoAPP(url, { ch: this.configurationData.channelID });
        return;
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
